<style>.formContainer {
	width: 100%;
    height: 100%;
    margin: 0 auto;
    display: block;
}
.formContainer > iframe {
	display: block;
}
.tf-v1-widget {
	width: 100%;
    height: 100%;
}
zoezi-af54a12dcc22a432 {
	width: 100%;
    height: 100%;
}</style>
<template><span class="formContainer"></span>
</template>
<script>export default {
    props: {
        formID: {
            title: 'TypeForm ID',
            type: String
        }
    },
    data() {
        return {
            formOptions: {
                autoResize: true,
                inlineOnMobile: true,
                container: null,
                hideHeaders: true,
                hideFooter: true,
                opacity: 0,
                onReady: null,
                iframeProps: {
                    display: 'block',
                	width: '100%',
                    height: '100%',
                }
            }
        };
    },
    mounted() {
        this.formOptions.container = this.$el;
        let formID = this.formID;
        let formOptions = this.formOptions;
        let embedScript = document.createElement('script');
        embedScript.onload = function() {
            window.tf.createWidget(formID, formOptions);
        };
        embedScript.setAttribute('id', 'tfEmbedTag');
        embedScript.setAttribute('src', '//embed.typeform.com/next/embed.js');
        /* let existingScriptTag = document.getElementById('tfEmbedTag');
        if (existingScriptTag !== null) {
        	existingScriptTag.addEventListener("load", () => {
            	window.tf.createWidget(formID, formOptions);
            });
        } else {
        	embedScript.addEventListener("load", () => {
            	window.tf.createWidget(formID, formOptions);
            });
            document.head.appendChild(embedScript);
        } */
        embedScript.addEventListener("load", () => {
            window.tf.createWidget(formID, formOptions);
        });
        document.head.appendChild(embedScript);
    }
}</script>